import { FEMALE_BENEFITS, OUTPATION_BENEFITS } from "context/apiContext";
import { equal, notEqual } from "./toolsHelper";
import { getCoverageOptionsVisibleFields } from "./CoverageOptionsVisibility";

/**
 * Per-step required-field lists for the favorite-plan template form's Next
 * button, mirroring the quoter's own mandatory-field gates (useSteps.jsx's
 * benefitsGenerator/stepsGenerator, quoter-only and deliberately untouched)
 * but checking only the step being left, not the quoter's cumulative
 * truncating-array behavior.
 */
export const getCoverageOptionsRequiredFields = (selectedBenefitsIds = {}, isCountryResidenceDeductible = false) =>
    getCoverageOptionsVisibleFields(selectedBenefitsIds, isCountryResidenceDeductible);

/**
 * Mirrors useSteps.jsx:198-204 - the same condition ImportantMessage.jsx
 * uses to decide whether the "limited coverage" acceptance checkbox even
 * renders.
 */
export const requiresLimitedCoverAcceptance = (selectedBenefitsIds = {}) => {
    if (equal(selectedBenefitsIds['geogrcov'], 'wwltd')) return true;
    return notEqual(selectedBenefitsIds['provdnet'], 'glopen');
};

export const getPlanBenefitsRequiredFields = (addDependant = false) => {
    const fields = ['congenit', 'hazardsp', 'inmental'];

    if (addDependant) {
        fields.push('deathcov');
    }

    return fields;
};

export const getOutpatientBenefitsRequiredFields = (outpationBenefitsEnabled = false) =>
    outpationBenefitsEnabled ? [...OUTPATION_BENEFITS] : [];

export const getMaternityRequiredFields = (outpationBenefitsmaternidad = false) =>
    outpationBenefitsmaternidad ? [...FEMALE_BENEFITS] : [];

export const getPreventiveCheckupRequiredFields = (step14Confirmation = false) =>
    step14Confirmation ? ['healthch'] : [];

export const getEyeSurgeryRequiredFields = () => ['eyesurgr'];
